<template>
  <keep-alive :include="aliveComponents">
    <router-view
      class="page-container"
      ref="pageContainer"
      @hook:mounted="handleMounted"
      @hook:deactivated="handleDeactivated"
      @hook:activated="handleActivated"
    ></router-view>
  </keep-alive>
</template>
<script>
export default {
  computed: {
    aliveComponents() {
      return this.$store.state.aliveComponents
    }
  },

  methods: {
    handleMounted() {
      !this.$refs.pageContainer.isAlive &&
        this.$refs.pageContainer.$el.addEventListener(
          'scroll',
          this.handleScroll
        )
    },

    handleActivated() {
      this.$refs.pageContainer.$el.scrollTo({
        top: this.$refs.pageContainer.scrollTop || 0
      })
      this.$refs.pageContainer.$el.addEventListener('scroll', this.handleScroll)
    },

    handleDeactivated() {
      this.$refs.pageContainer.isAlive = true
      this.$refs.pageContainer.$el.removeEventListener(
        'scroll',
        this.handleScroll
      )
    },

    handleScroll() {
      this.$refs.pageContainer.scrollTop =
        this.$refs.pageContainer.$el.scrollTop
    }
  }
}
</script>
